import React from 'react';
import { X, Building2, Mail, Phone, FileText, MapPin, Briefcase, Globe, BookOpen } from 'lucide-react';
import './Modal.css';

const ImprintModal = ({ isOpen, onClose, t, isArabic }) => {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={28} />
        </button>
        
        <div className="modal-body">
          <div className="modal-header">
            <FileText size={40} className="modal-header-icon" />
            <h2 className="modal-title">{t.imprint.title}</h2>
          </div>

          <div className="modal-sections imprint-grid">
            <div className="modal-section">
              <h3 className="modal-section-title">{t.imprint.responsible}</h3>
              <div className="modal-info">
                <div className="modal-info-item">
                  <Building2 size={20} />
                  <span className="ltr">Sami Chalhoub</span>
                </div>
                <div className="modal-info-item">
                  <MapPin size={20} />
                  <span className="ltr">{t.contact.addressValue}</span>
                </div>
              </div>
            </div>

            <div className="modal-section">
              <h3 className="modal-section-title">{t.imprint.contact}</h3>
              <div className="modal-info">
                <div className="modal-info-item">
                  <Phone size={20} />
                  <span className="ltr">+49 152 2657 3461</span>
                </div>
                <div className="modal-info-item">
                  <Mail size={20} />
                  <a className="ltr" href="mailto:sami.chalhoub@chalhoubtrade.de">sami.chalhoub@chalhoubtrade.de</a>
                </div>
              </div>
            </div>

            <div className="modal-section">
              <h3 className="modal-section-title">{t.imprint.tax}</h3>
              <div className="modal-info">
                <div className="modal-info-item">
                  <FileText size={20} />
                  <span>
                    {t.imprint.vatLabel}: <span className="ltr">DE357120324</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="modal-section">
              <h3 className="modal-section-title">{t.imprint.dispute}</h3>
              <div className="modal-info">
                <div className="modal-info-item">
                  <FileText size={20} />
                  <span>
                    <strong>{t.imprint.disputeConsumerLabel}:</strong> {t.imprint.disputeConsumerText}
                  </span>
                </div>
              </div>
            </div>

            <div className="modal-section professional-section">
              <h3 className="modal-section-title">{t.imprint.professional}</h3>
              <div className="modal-info">
                <div className="modal-info-item">
                  <Briefcase size={20} />
                  <span>
                    <strong>{t.imprint.professionalJobTitle}:</strong><br />
                    {t.imprint.professionalJobTitleText}
                  </span>
                </div>
                <div className="modal-info-item">
                  <Building2 size={20} />
                  <span>
                    <strong>{t.imprint.professionalAuthority}:</strong><br />
                    {isArabic ? (
                      <span className="ltr-block">{t.imprint.professionalAuthorityText}</span>
                    ) : (
                      t.imprint.professionalAuthorityText
                    )}
                    <br />
                    <span>
                      {isArabic ? 'الموقع الإلكتروني: ' : 'Website: '}
                      <a href="https://www.blak.de" target="_blank" rel="noopener noreferrer" className="ltr">
                        {t.imprint.professionalAuthorityWebsite}
                      </a>
                    </span>
                  </span>
                </div>
                <div className="modal-info-item">
                  <Globe size={20} />
                  <span>
                    <strong>{t.imprint.professionalSupervisoryAuthority}:</strong><br />
                    {isArabic ? (
                      <span className="ltr-block">{t.imprint.professionalSupervisoryAuthorityText}</span>
                    ) : (
                      t.imprint.professionalSupervisoryAuthorityText
                    )}
                  </span>
                </div>
                <div className="modal-info-item">
                  <BookOpen size={20} />
                  <span>
                    <strong>{t.imprint.professionalRegulations}:</strong><br />
                    {isArabic ? (
                      <>
                        {t.imprint.professionalRegulationsName}
                        <br />
                        {t.imprint.professionalRegulationsText}
                      </>
                    ) : (
                      t.imprint.professionalRegulationsText
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImprintModal;